import { renderRoutes } from '../utils/renderRoutes'

export default ({ route, extraProps, switchProps }) =>
  renderRoutes(route.routes, extraProps, switchProps)
